import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const TwitterIcon: IconComponent = ({ className, colorCode = 'p500', width = 25, height = 26 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 25 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.8812 11.5263L24.189 0.939453H21.9836L13.898 10.13L7.44478 0.939453H0L9.76074 14.8384L0 25.9395H2.20535L10.7388 16.2317L17.5552 25.9395H25L14.8812 11.5263ZM11.8596 14.9604L10.8692 13.5755L3.00065 2.56632H6.38853L12.7405 11.4545L13.7268 12.8394L21.9826 24.3919H18.5947L11.8596 14.9604Z"
                fill={color}
            />
        </svg>
    )
}
